/*
As of 3/2023, only Korttiapuri sub-application uses Adobe Analytics.
If taken into use with other sub-applications, support for it has to be implemented.
*/

interface BasicData {
  name: string;
  channel: string;
  group: string;
  business_group: string;
}

interface PhaseData extends BasicData {
  phase_category: string;
  phase: string;
  language: string;
}

interface ActionData extends BasicData {
  action_name: string;
  action_group: string;
  phase: string;
  language: string;
}

interface CommonActionData {
  common_action: string;
  action_group: string;
}

const BASIC_ANALYTICS_DATA: BasicData = {
  name: 'KorttiApuri',
  channel: 'ha',
  group: 'tool',
  business_group: 'bank',
};

const LANGUAGES = new Map([
  ['fi', 'fi_fi'],
  ['sv', 'sv_se'],
  ['en', 'en_us'],
]);

const logAnalytics = (params: PhaseData | ActionData | CommonActionData) => {
  /* eslint-disable no-console */
  console.group('Analytics data:');
  console.log(params);
  console.groupEnd();
  /* eslint-enable */
};

const getLang = (): string => {
  return LANGUAGES.get(document.documentElement.getAttribute('lang')!) ?? 'fi_fi';
};

const sendAdobeAnalyticsData = (
  analyticsParams: PhaseData | ActionData | CommonActionData,
  dataType: 'application_phase' | 'application_action' | 'common_action',
) => {
  if (process.env.NODE_ENV === 'development') {
    logAnalytics(analyticsParams);
  } else {
    try {
      if (window._satellite) {
        window._satellite.track(dataType, analyticsParams);
      }
    } catch {
      // Do nothing
    }
  }
};

export const sendAdobeAnalyticsPhaseData = (phaseCategory: string, phase: string) => {
  const params: PhaseData = {
    ...BASIC_ANALYTICS_DATA,
    phase_category: phaseCategory,
    phase: phase,
    language: getLang(),
  };

  sendAdobeAnalyticsData(params, 'application_phase');
};

export const sendAdobeAnalyticsActionData = (actionName: string, actionGroup: string, phase: string) => {
  const params: ActionData = {
    ...BASIC_ANALYTICS_DATA,
    action_name: actionName,
    action_group: actionGroup,
    phase: phase,
    language: getLang(),
  };

  sendAdobeAnalyticsData(params, 'application_action');
};

export const sendAdobeAnalyticsCommonActionData = (commonAction: string | undefined, actionGroup: string) => {
  if (commonAction) {
    const params: CommonActionData = {
      common_action: commonAction,
      action_group: actionGroup,
    };

    sendAdobeAnalyticsData(params, 'common_action');
  } else {
    // Do nothing
  }
};
